import { useMemo } from 'react';
import { useGlobalStore } from '../stores/useGlobalStore';
export const useAccessUtils = () => {
    const getUserInfo = useGlobalStore(state => state.getUserInfo);
    // 获取平铺后的权限数组
    const permissions = useMemo(() => {
        const rolePermissions = getUserInfo()?.rolePermissions || {};
        return Object.values(rolePermissions).flat();
    }, [getUserInfo]);
    // 返回判断方法
    return {
        can: (perm) => permissions.includes(perm),
        any: (perms) => perms.some(p => permissions.includes(p)),
        raw: permissions
    };
};
